// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedAnalyzeScreensEdit_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12.6863 20.8196L11.5 24L14.8076 22.9452L21.8787 15.8597L19.7574 13.7341L12.6863 20.8196ZM20.4645 13.0255L21.8787 11.6084L24 13.7341L22.5858 15.1512L20.4645 13.0255Z" class="svg-bg"/>
  <path d="M0 12.0245C0 17.8367 4.1153 22.6858 9.5854 23.8055L10.2235 21.8873C5.54813 21.0473 2 16.9511 2 12.0245C2 6.49039 6.47716 2.00409 12 2.00409C16.4777 2.00409 20.268 4.953 21.5422 9.01839H23.622C22.2898 3.83213 17.5915 0 12 0C5.37259 0 0 5.38356 0 12.0245Z" class="svg-bg"/>
  <path d="M10.7655 19.946L12.6496 18.002C12.4362 18.025 12.2195 18.0368 12 18.0368C8.6863 18.0368 6.00001 15.345 6.00001 12.0245C6.00001 8.70405 8.6863 6.01226 12 6.01226C15.3137 6.01226 18 8.70405 18 12.0245C18 12.2183 17.9909 12.4099 17.973 12.599L19.8844 10.659C19.2376 6.88216 15.9537 4.00818 12 4.00818C7.58173 4.00818 4.00001 7.59722 4.00001 12.0245C4.00001 16.0311 6.93335 19.3512 10.7655 19.946Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12 16.0327C14.2092 16.0327 16 14.2382 16 12.0245C16 9.81087 14.2092 8.01635 12 8.01635C9.79087 8.01635 8.00001 9.81087 8.00001 12.0245C8.00001 14.2382 9.79087 16.0327 12 16.0327ZM12 14.0286C13.1046 14.0286 14 13.1314 14 12.0245C14 10.9177 13.1046 10.0204 12 10.0204C10.8954 10.0204 10 10.9177 10 12.0245C10 13.1314 10.8954 14.0286 12 14.0286Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedAnalyzeScreensEdit is a generated icon component.
 */
let IconMedAnalyzeScreensEdit = IconMedAnalyzeScreensEdit_1 = class IconMedAnalyzeScreensEdit extends IconBaseElement {
    render() {
        return html `${IconMedAnalyzeScreensEdit_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedAnalyzeScreensEdit.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedAnalyzeScreensEdit = IconMedAnalyzeScreensEdit_1 = __decorate([
    customElement('zui-icon-med-analyze-screens-edit')
], IconMedAnalyzeScreensEdit);
export { IconMedAnalyzeScreensEdit };
